import content from "../../content.json";
import * as classes from "./lookbook.module.scss";
import "../../../node_modules/swiper/swiper.min.css";
import { Swiper } from "swiper/react/swiper";
import SwiperCore, { Autoplay, FreeMode, Mousewheel, Keyboard } from "swiper";
import { SwiperSlide } from "swiper/react/swiper-slide";
import { AppContext, ViewMode } from "../../contexts/AppContext";
import { useContext, useState } from "react";
import LookbookItem from "./LookbookItem";
import { useEffect } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classNames from "classnames";
SwiperCore.use([Autoplay, FreeMode, Mousewheel, Keyboard]);

const Lookbook = () => {
  const { state } = useContext(AppContext);
  const { viewMode } = state;
  const [isAutoplay, setIsAutoplay] = useState(true);
  const [preventClickChild, setPreventClickChild] = useState(false);

  useEffect(() => {
    setIsAutoplay(true);
  }, [viewMode]);

  return (
    <TransitionGroup component={null}>
      {viewMode == ViewMode.Lookbook ? (
        <CSSTransition key="lookbook" timeout={333}>
          <div className={classes.root}>
            <h2
              style={{
                opacity: 0,
                position: "absolute",
                pointerEvents: "none",
              }}
            >
              Lookbook
            </h2>
            <Swiper
              className={classNames(classes.swiper, {
                [classes["swiper--autoplay"]]: isAutoplay,
              })}
              slidesPerView="auto"
              centeredSlides
              keyboard
              spaceBetween={0}
              grabCursor
              mousewheel
              freeMode={{
                enabled: true,
                sticky: false,
                minimumVelocity: 0.1,
                momentumRatio: 0.8,
                momentumVelocityRatio: 0.8,
              }}
              loop
              autoplay={{ delay: 0 }}
              onAutoplayStop={() => setIsAutoplay(false)}
              speed={isAutoplay ? 6000 : 500}
              onTouchStart={() => {
                setPreventClickChild(false);
              }}
              onSliderMove={() => {
                setPreventClickChild(true);
              }}
              onTouchEnd={() => {
                requestAnimationFrame(() => {
                  setPreventClickChild(false);
                });
              }}
              threshold={3}
            >
              {Object.keys(content.looks).map((key) => {
                return (
                  <SwiperSlide key={key} className={classes.slide}>
                    {({ isActive }) => (
                      <LookbookItem
                        name={key}
                        preventClick={preventClickChild}
                        isActive={isActive}
                      />
                    )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
};

export default Lookbook;
